import { render } from "./DeleteItemModal.vue?vue&type=template&id=372bc098&scoped=true"
import script from "./DeleteItemModal.vue?vue&type=script&lang=js"
export * from "./DeleteItemModal.vue?vue&type=script&lang=js"

import "./DeleteItemModal.vue?vue&type=style&index=0&id=372bc098&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-372bc098"]])

export default __exports__